import fitnessImage from '$lib/assets/images/sweat-fitness-katie.jpg';
import nutritionImage from '$lib/assets/images/sweat-nutrition-kayla.jpg';
import wellbeingImage from '$lib/assets/images/sweat-wellbeing-kelsey.jpg';
import communityImage from '$lib/assets/images/sweat-community-kayla.jpg';
import muscleGroups from '$lib/assets/images/muscle-group-base-image.png';

export const CONTENT_TYPES = {
  HOMEPAGE: 'HomePage',
  CONTENT_PAGE: 'ContentPage',
  ARTICLE: 'Article',
  PICTURE_PANEL: 'PicturePanel',
  UTILITY_PANEL: 'UtilityPanel',
  NAVIGATION_ITEM: 'NavigationItem',
  RICH_TEXT_PANEL: 'RichTextPanel',
  NEWSLETTER_SUBSCRIPTION_PANEL: 'NewsletterSubscriptionPanel',
  AUTHOR_PANEL: 'AuthorPanel',
  HERO_BANNER: 'HeroBanner',
  CTA_PANEL: 'CtaPanel',
  EQUIPMENT_PANEL: 'EquipmentPanel',
  ACCORDION: 'Accordion',
  EMBED_PANEL: 'EmbedPanel',
  USP_PANEL: 'UspPanel',
  REVIEW_PANEL: 'ReviewPanel',
  DOUBLE_WEB_COLUMN: 'DoubleWebColumn',
  WEB_COLUMN: 'WebColumn',
  CARD_PANEL: 'CardPanel',
  EXERCISE_PANEL: 'ExercisePanel',
  REST_PANEL: 'RestPanel',
  WORKOUT_PANEL: 'WorkoutPanel',
  PARTNER_PANEL: 'PartnerPanel',
  VARIATION_CONTAINER: 'VariationContainer',
  HERO_BANNER_CAROUSEL: 'HeroBannerCarousel',
} as const;

export type VALID_CONTENT_TYPES = (typeof CONTENT_TYPES)[keyof typeof CONTENT_TYPES];

export const BUTTON_VARIANT = {
  PRIMARY: 'Primary (pink)',
  SECONDARY: 'Secondary (purple)',
  OUTLINED: 'Secondary (grey)',
  CUSTOM: 'Custom',
  FACEBOOK: 'Facebook',
};

export const BUTTON_SIZE = {
  LARGE: 'Large',
  MEDIUM: 'Medium',
  CUSTOM: 'Custom',
};

export const DESKTOP_TEXT_ALIGNMENT = {
  LEFT: 'Left aligned',
  CENTER: 'Centre aligned',
  BOTTOM: 'Bottom aligned',
};
export const CTA_VARIANT = {
  FULL: 'Full-width, grey background',
  GREY: 'Padding, grey background',
  PINK: 'Padding, pink background and white text',
};

export const ACCORDION_ITEM_VARIANT = {
  DEFAULT: 'default',
  NAV: 'nav',
};

export const ACCORDION_VARIANT = {
  STANDARD: 'Standard',
  FAQ: 'FAQ',
  FAQ_CTA: 'FAQ with CTA',
};

export const REVIEW_VARIANT = {
  WHITE: 'White Background',
  GREY: 'Grey Background',
};

export const EXERCISE_LISTING_SKIP = 16;
export const ARTICLE_LISTING_SKIP = 15;
export const PROGRAM_LISTING_SKIP = 15;
export const TRAINER_LISTING_SKIP = 15;

export const ARTICLE_CATEGORY_CARDS = [
  {
    alt: 'fitness image',
    imageSrc: fitnessImage,
    url: '/blogs/fitness',
  },
  {
    alt: 'nutrition image',
    imageSrc: nutritionImage,
    url: '/blogs/nutrition',
  },
  {
    alt: 'wellbeing image',
    imageSrc: wellbeingImage,
    url: '/blogs/wellbeing',
  },
  {
    alt: 'community image',
    imageSrc: communityImage,
    url: '/blogs/community',
  },
] as const;

export const MUSCLE_GROUPS = {
  alt: 'Muscle Groups - Body',
  imageSrc: muscleGroups,
} as const;

export const CARD_VARIANT = {
  STANDARD: 'Standard Card',
  PROGRAM: 'Program Card',
};

export const CARD_PANEL_VARIANT = {
  GRID: 'Grid',
  SLIDER: 'Slider',
};

export const CARD_PANEL_HEADING_ALIGNMENT = {
  LEFT: 'Left',
  CENTER: 'Center',
};

export const HEADER_VARIANT = {
  DEFAULT: 'White background with Black text (default)',
  INVERT: 'Black background with White text',
  TRANSPARENT: 'Transparent background with White text',
};

export const OPT_IN_MARKETING_COUNTRIES = ['US'];
